import React, { useEffect, useState } from 'react';
import { Alert, Badge, Button, Card, Col, Row, Statistic, Table, Tooltip, Typography } from 'antd';
import { Company } from '../../models/company-interface';
import { DashboardQueries } from '../../queries/dashboard-queries';
import { ShortDateStringForUser } from '../../utilites/dateTimeHelper';
import { DateFormat } from '../../constants/dateFormat';
import { useHistory } from 'react-router';
import { SalesforceCompany } from '../../models/salesforce-company-interface';
import './Dashboard.scss';
const { Text } = Typography;

function DashboardPage() {
  const history = useHistory();
  const productStatsQuery = DashboardQueries.useProductStats();
  const latestCompaniesQuery = DashboardQueries.useLatestCompanies();
  const salesforceDisabledCompaniesQuery = DashboardQueries.useSalesforceDisabledCompanies();
  const [activeTab,setActiveTab] = useState<string>("latest");

  const isLatestCompaniesLoading = latestCompaniesQuery.isLoading;
  const isSalesforceDisabledCompaniesLoading = salesforceDisabledCompaniesQuery.isLoading;

  /**
   * Navigate to company page
   * @param e 
   * @param id 
   */
  const handleClick = (e: React.MouseEvent<HTMLElement, MouseEvent>, id: any) => {
    e.preventDefault();
    history.push(`/admin/company/${id}`);
  }

  const zuoreColumns: any = [
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      render: date => ShortDateStringForUser(date, DateFormat.MonthDayYear)
    },
    {
      title: 'ID',
      dataIndex: 'companyId',
      key: 'id',
    },
    {
      title: 'Company',
      dataIndex: 'companyName',
      key: 'name',
      render: (companyName: string, record: SalesforceCompany) => (
        <Button
          id={`salesforceCompanyNameButton-${record.companyId}`}
          type="link"
          href={`/admin/company/${record.companyId}`}
          onClick={(e) => handleClick(e, record.companyId)}
        >
          {companyName}
        </Button>
      )
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: action => <strong className={action}>{action}</strong>
    },
    {
      title: 'Reason',
      dataIndex: 'reason',
      key: 'reason',
      width: '200px'
    }
  ]

  const columns: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id'
    },
    {
      title: 'Company',
      dataIndex: 'name',
      key: 'name',
      render: (name: string, record: Company) => (
        <Button
          id={`companyNameButton-${record.id}}}`}
          type="link"
          href={`/admin/company/${record.id}`}
          onClick={(e) => handleClick(e, record.id)}
        >
          {name}
        </Button>
      )
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (_: any, record: { confirmed: boolean; }) => (
        record.confirmed ? "Active" : "Disabled"
      )
    }
  ];

  
  const tabList = [
          {
            key: 'latest',
            tab: (
              <>
                Latest Signups
              </>
            ),
            disabled: false,
          },
          {
            key: 'salesforce',
            tab: (
              <>
                Salesforce Sync Actions <Badge count={salesforceDisabledCompaniesQuery.data?.map(x => ({ ...x, key: x.companyId })).length ?? 0} />
              </>
            ),
            disabled: (salesforceDisabledCompaniesQuery.data?.map(x => ({ ...x, key: x.companyId })) ?? 0) === 0,
          },
        ];

  return <>
    <Row gutter={[16,16]}>
      <Col sm={24} md={8}>
      <Row gutter={[16,16]}>
        <Col span={24}>
          <Card>
            <Tooltip title="Excluding demo and trial companies">
            <Statistic 
              title="Active Companies"
              value={productStatsQuery.data?.activeCompanies ?? 0}
            />
            </Tooltip>
          </Card>
        </Col>
        <Col span={24}>
          <Card>
          <Tooltip title="Unique active and notified users, excluding users on demo and trial companies">
            <Statistic 
              title="Active Users"
              value={productStatsQuery.data?.activeUsers ?? 0}
            />
            </Tooltip>
          </Card>
        </Col>
        <Col span={24}>
          <Card>
          <Tooltip title="Active, non-demo companies with a Trial subscription">
            <Statistic 
              title="In-Trial Companies"
              value={productStatsQuery.data?.activeTrials ?? 0}
            />
            </Tooltip>
          </Card>
        </Col>
      </Row>
      </Col>
      <Col sm={24} md={16}>
        <Card tabList={tabList} activeTabKey={activeTab} onTabChange={(t) => setActiveTab(t)} bordered={false} >
          {activeTab == "latest" ? 
          <>
          <Alert message="Last 10 companies signed up" style={{marginBottom: 20}}/>
          <Table
            loading={isLatestCompaniesLoading}
            columns={columns}
            dataSource={latestCompaniesQuery.data?.map(x => ({ ...x, key: x.id }))}
            pagination={false}
            size="small"
            scroll={{ x: 'max-content' }}
          />
          </> : 
          <>
          <Alert message="Sync actions that have occurred in the past 5 days" style={{marginBottom: 20}}/>
          <Table
            id="zuoreCompanyTable"
            loading={isSalesforceDisabledCompaniesLoading}
            columns={zuoreColumns}
            dataSource={salesforceDisabledCompaniesQuery.data?.map(x => ({ ...x, key: x.companyId }))}
            pagination={false}
            size="small"
            scroll={{ x: 'max-content' }}
          />
          </>}
        </Card>
      </Col>
    </Row>
  </>
}

export default DashboardPage;
